import { Api } from 'api';
import { ProblemDetails } from 'helpers/problemDetails';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Benchmark } from 'types/Benchmark';
import { useTWScreenParams } from './useTimeWindows';

type props = {
  originalValues: any;
  originalTimeWindows?: Array<any>;
  getBody: (
    originalValues: any,
    newValues: any,
    originalTimeWindows?: Array<any>
  ) => Benchmark;
};

export const useSubmit = ({
  originalValues,
  originalTimeWindows,
  getBody,
}: props) => {
  const { mutate, isSuccess, data, isLoading }: any =
    Api.benchmarks.SaveBenchmarks();
  const history = useHistory();
  const { pathname } = useLocation();
  const { isTimeWindowsScreen } = useTWScreenParams();

  const [errors, setErrors] = useState<ProblemDetails>();

  const onSubmit = (values: any) => {
    const body = getBody(originalValues, values, originalTimeWindows);
    mutate(
      { body },
      {
        onError: (data: any) => {
          setErrors(new ProblemDetails(data.response.data));
        },
      }
    );
  };

  useEffect(() => {
    if (!isLoading && isSuccess) {
      const { id } = data.data;
      if (!originalValues?.id && id) {
        history.push({
          pathname: `${pathname}/${id}`,
          search: new URLSearchParams(history.location.search).toString(),
        });
      }

      if (originalValues?.id && isTimeWindowsScreen) {
        // go back to benchmark screen
        history.push(pathname);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, data?.data]);

  return {
    onSubmit,
    isSuccess,
    isLoading,
    errors,
  };
};
